export const colors = {
  primary: '#2563eb', // Blue
  primaryDark: '#1d4ed8',
  secondary: '#64748b', // Gray
  text: {
    primary: '#1e293b', // Dark blue
    secondary: '#64748b', // Gray
    light: '#94a3b8', // Light gray
  },
  background: {
    primary: '#ffffff',
    secondary: '#f8fafc',
    tertiary: '#f1f5f9',
  },
  border: '#e2e8f0',
  borderVariants: {
    light: '#e2e8f0',
    medium: '#cbd5e1',
    dark: '#94a3b8',
  },
  status: {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
  },
}